var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-card"},[_c('div',{staticClass:"header"},[_c('h4',[_vm._v(" Articulos vendidos desde hace un año ")]),_c('chart-options',{attrs:{"store_name":"articulos_vendidos","total_registros_text":_vm.total_registros_text,"registros_para_mostrar":_vm.unidades_vendidas}})],1),_c('articulos-vendidos')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }